export default {
	rental_evaluation: {
		en: "Rental Valuation",
		ar: "تثمين الايجار",
	},
	i_want_rental_valuation_on: {
		en: "I want to request for rental valuation",
		ar: "أريد تقييم الإيجار ل",
	},
	on_my_property: {
		en: "On my property",
		ar: "عقاراتي",
	},
	on_my_leased_property: {
		en: "On my leased property",
		ar: "على عقاراتي المؤجرة",
	},
	on_behalf_of: {
		en: "On behalf of",
		ar: "نيابة عن",
	},
	evaluate: {
		en: "Evaluate",
		ar: "التقييم",
	},
	view_all: {
		en: "View All",
		ar: "عرض الكل",
	},
	select_properties_for_valuation: {
		en: "Select properties for valuation",
		ar: "حدد العقارات للتقييم",
	},
	properties_selected: {
		en: "Properties selected",
		ar: "تم تحديد العقارات",
	},
	property_selected: {
		en: "Selected Property",
	},
	rv_prop_info_msg: {
		en: "Please note that you will be required to add separate documents for all the added properties. You will be able to submit the request only when all required documents are uploaded.",
		ar: "يرجى ملاحظة أنه سيُطلب منك إضافة مستندات منفصلة لجميع العقارات المضافة. ستتمكن من إرسال الطلب فقط عندما يتم تحميل جميع المستندات المطلوبة.",
	},
	do_you_want_to_delete_property: {
		en: "Do you want to delete the selected property?",
		ar: "هل تريد حذف العقار المحدد؟",
	},
	plus_more: {
		en: "+ More",
		ar: "+ المزيد",
	},
	rv_property_cannot_added: {
		en: "This property cannot be added to the current valuation",
		ar: "لا يمكن إضافة هذا العقار إلى التقييم الحالي",
	},
	rv_property_cannot_added_unit: {
		en: "Only units in the same building can be evaluated at a time",
		ar: "يمكن تقييم الوحدات العقارية في نفس المبنى فقط",
	},
	rv_property_cannot_added_villa: {
		en: "Only villas in the same land can be evaluated at a time",
		ar: "يمكن تقييم الفلل الموجودة في نفس الأرض فقط",
	},
	rv_property_cannot_added_building: {
		en: "Only buildings in the same land can be evaluated at a time",
		ar: "يمكن تقييم المباني الموجودة في نفس الأرض فقط",
	},
	rv_property_cannot_added_land: {
		en: "Only Lands in the same area can be evaluated at a time",
		ar: "يمكن تقييم الأراضي الموجودة في نفس المنطقة فقط",
	},
	is_this_completed_property: {
		en: "Is this a completed property?",
		ar: "هل هذا العقار مكتمل؟",
	},
	reason_for_valuation: {
		en: "Reason for Valuation",
		ar: "سبب التقييم",
	},
	summary: {
		en: "Summary",
		ar: "الملخص",
	},
	proposed_fee_structure: {
		en: "Proposed fee structure",
		ar: "هيكل الرسوم المقترح",
	},
	note_pay_fee_after_audit: {
		en: "Please note that you will be required to pay the amount only after auditor approval.",
		ar: "يرجى ملاحظة أنه لن يُطلب منك دفع المبلغ إلا بعد موافقة المدقق.",
	},
	type_of_valuation: {
		en: "Type of Valuation",
		ar: "نوع التقييم",
	},
	rv_request_submitted: {
		en: "Your request for valuation has been submitted successfully.",
		ar: "لقد تم تقديم طلبك للتقييم بنجاح.",
	},
	next_step: {
		en: "Next Step",
		ar: "الخطوة التالية",
	},
	track_progress_in_my_requests: {
		en: "Track the progress of your application in \"My Requests\"",
		ar: "تتبع تقدم طلبك في \"طلباتي\"",
	},
	rental_evaluation_requests: {
		en: "Rental Valuation Requests",
		ar: "طلبات تقييم الإيجار",
	},
	request_date: {
		en: "Request Date",
		ar: "تاريخ الطلب",
	},
	download_request_report: {
		en: "Download Request Report",
		ar: "تنزيل تقرير الطلبات",
	},
	download_eval_certificate: {
		en: "Download Valuation Certificate",
		ar: "تحميل شهادة التقييم",
	},
	rv_payment_success: {
		en: "Your payment has been successful",
		ar: "تم الدفع بنجاح",
	},
	rv_note_ref: {
		en: "Please note the Reference Number for any further communication",
		ar: "يرجى ملاحظة الرقم المرجعي لأي استفسارات لاحقة",
	},
	unitNo: {
		en: "Unit #",
		ar: "رقم الوحدة",
	},
	building: {
		en: "Building",
		ar: "مبنى",
	},
	villa: {
		en: "Villa",
		ar: "فيلا",
	},
	land_number: {
		en: "Land #",
		ar: "رقم الأرض",
	},
	rental_index: {
		en: "Rental Index",
		ar: "مؤشر الإيجار",
	},
	municipality_no: {
		en: "Municipality No.",
		ar: "رقم البلدية",
	},
	property_delete_confirmation: {
		en: "Please confirm to delete selected property.",
		ar: "يرجى التأكيد للحذف",
	},
	add_more: {
		en: "Add More",
		ar: "أضف المزيد",
	},
	dm_number: {
		en: "DM #",
		ar: "رقم البلدية",
	},
	land_sub: {
		en: "Land Sub No.",
		ar: "رقم الأرض الفرعي",
	},
	building_name: {
		en: "Building Name",
		ar: "اسم المبنى",
	},
	dm_subNo: {
		en: "DM Sub No.",
		ar: "رقم البلدية الفرعي",
	},
	completion_date: {
		en: "Completion Date",
		ar: "موعد الإنتهاء",
	},
	unified_reference_number: {
		en: "Unified Reference Number",
		ar: "الرقم المرجعي الموحد",
	},
	invalid_emirates_id_information: {
		en: "Invalid Emirates ID information",
		ar: "رقم البطاقة غير صحيح",
	},
	rental_evaluation_details: {
		en: "Rental Valuation Details",
		ar: "معلومات تثمين الايجار",
	},
	download_receipt: {
		en: "Download Receipt",
		ar: "تنزيل الإيصال",
	},
	total_properties: {
		en: "Total properties",
		ar: "مجموع العقارات",
	},
	property_type: {
		en: "Property Type",
		ar: "نوع العقار",
	},
	reason: {
		en: "Reason",
		ar: "سبب",
	},
	clear_all: {
		en: "Clear All",
		ar: "إلغاء الكل",
	},
	proceed_fill_missing_field: {
		en: "To proceed, Please fill in the missing fields by clicking on info icon",
		ar: "للمتابعة يرجى ادخال البيانات المتبقية عن طريق الضغط على ايقونة المعلومات",
	},

};
